export default "__VITE_ASSET__a7d553b8__"